export const formatAssignmentStatus = (status) => {
  const map = {
    PENDING: {
      label: "Not Started",
      bgColor: "#EFF6FF",
      textColor: "#1D4ED8",
      icon: "",
      userFacing: true,
    },
    IN_PROGRESS: {
      label: "In Progress",
      bgColor: "#F0FDF4",
      textColor: "#15803D",
      icon: "",
      userFacing: true,
    },
    SUBMITTED: {
      label: "Submitted",
      bgColor: "#FEFCE8",
      textColor: "#A16207",
      icon: "",
      userFacing: true,
    },
    DONE: {
      label: "Done",
      bgColor: "#F9FAFB",
      textColor: "#6B7280",
      icon: "",
      userFacing: false,
    },
    RETURNED: {
      label: "Returned",
      bgColor: "#FFF7ED",
      textColor: "#C2410C",
      icon: "",
      userFacing: false,
    },
    REJECTED: {
      label: "Needs Rework",
      bgColor: "#FFFBEB",
      textColor: "#B45309",
      icon: "",
      userFacing: true,
    },
    REASSIGNED: {
      label: "Reassigned",
      bgColor: "#F9FAFB",
      textColor: "#6B7280",
      icon: "",
      userFacing: false,
    },
    REMOVED: {
      label: "Removed",
      bgColor: "#F9FAFB",
      textColor: "#6B7280",
      icon: "",
      userFacing: false,
    },
    SKIPPED: {
      label: "Skipped",
      bgColor: "#F9FAFB",
      textColor: "#9CA3AF",
      icon: "",
      userFacing: false,
    },
  };

  return (
    map[status] ?? {
      label: status || "-",
      bgColor: "#F9FAFB",
      textColor: "#6B7280",
      icon: ".",
      userFacing: false,
    }
  );
};
